import React from 'react';

const BreadTag = ({title, item1, item2, item3, onClick1, onClick2, onClick3}) => {
  return (
    <div className='flex justify-between items-center mb-6 md:text-[20px] leading-[24px]  py-6 rounded-lg'>
      <div className='flex items-center space-x-2'>
        <span
          onClick={onClick1}
          className='text-neutral hover:underline cursor-pointer'>
          {item1}
        </span>
        {item2 && (
          <>
            <span className='text-neutral text-[20px]'>/</span>
            <span
          onClick={onClick2}
          className='text-neutral hover:underline cursor-pointer '>
          {item2}
        </span>
          </>
        )}
        {item3 && (
          <>
            <span className='text-blueColor text-base'>/</span>
            <span className='text-blueColor font-semibold'>{item3}</span>
          </>
        )}
      </div>
      <p onClick={onClick3} className=' font-ManropeBold text-blueColor cursor-pointer'>{title}</p>
    </div>
  );
};

export default BreadTag;
